module.exports = __webpack_public_path__ + "img/V10.569ef00d.png";